import { Button, Grid } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../../resources/theme/global'

import { useQueryParams } from '../../../../util/utils'
import { usePermissions } from '../../../../hooks/usePermission'
import colors from '../../../../assets/colors'
import Filter from './Filter'
import List from './List'
import ModalShowVisits from '../../../attendance/pages/ModalShowVisits'
import { Route } from 'react-router-dom/cjs/react-router-dom'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { fetchAttendancePartner } from '../PartnerAttendanceActions'

const PartnersOss = props => {
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canRead } = usePermissions()
  const dispatch = useDispatch()

  const { classes } = props

  const location = useLocation()
  const filters = useQueryParams(location.search)

  useEffect(() => {
    dispatch(
      fetchAttendancePartner(filters, filters?.rows || 10, filters?.page || 1)
    )
  }, [location])

  return (
    <>
      <Grid
        container
        className={classes.pageHead}
        spacing={2}
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography
            variant="h4"
            style={{ fontSize: '20px' }}
            color={colors.primary}
          >
            OSs de Parceiros
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Filter classes={classes} />
        </Grid>

        {canRead('modulo-parceiros-oss', permissionUser) && <List />}
      </Grid>

      {canRead('modulo-parceiros-oss', permissionUser) && (
        <Route
          path="/partners-module/oss/visits/:id"
          component={ModalShowVisits}
        />
      )}
    </>
  )
}

export default withStyles(styles)(PartnersOss)
